import { Point } from '@printu/geom';
import { getItemBounds } from 'app/core/markers/bounds';
import { getMarkerText, getScaledFontSize } from 'app/core/markers/models';
import { TextMeasurer } from 'app/core/text/TextMeasurer';
import { calculateCloudPath } from 'app/views/components/editor/tools/edit/text/cloud';
export const DefaultTextValues = {
    multiline: 'Insert\nText\nOr\nNot\nNot\nNot\nNot\nNot\nLast line!',
    singleline: 'Insert text',
};
export const measureText = (text, format, measurerSelector = '.text-measurer', size = undefined) => {
    const el = document.querySelector(measurerSelector);
    const textMeasurer = new TextMeasurer({ el });
    const { width, height, lines } = textMeasurer.measureText(text, format, size);
    textMeasurer.detach();
    return { lines, width, height };
};
export const measureMarker = (marker, opts) => {
    const { fontSize, sizeFactor = 1.0, measurerSelector = '.text-measurer', explicitFormat, } = opts;
    let formatPatch = {};
    if (fontSize) {
        const effectiveFontSize = getScaledFontSize(fontSize, sizeFactor);
        formatPatch = Object.assign(Object.assign({}, formatPatch), { fontSize: effectiveFontSize });
    }
    if (explicitFormat) {
        formatPatch = Object.assign(Object.assign({}, formatPatch), explicitFormat);
    }
    const format = Object.assign(Object.assign({}, marker.format), formatPatch);
    const metrics = measureText(getMarkerText(marker), format, measurerSelector);
    return { format, metrics };
};
export const getInternalCloudRect = (width, height, factor = 1.1) => {
    const cloudOriginX = width * 0.5;
    const cloudOriginY = height * 0.5;
    const cloudWidth = width * factor;
    const cloudHeight = height * factor;
    return {
        center: { x: cloudOriginX, y: cloudOriginY },
        width: cloudWidth,
        height: cloudHeight,
    };
};
export const getTextCloudPath = (marker, newTailPoint) => {
    const bounds = getItemBounds(marker);
    const { tail, radius } = marker.background;
    const { x, y } = newTailPoint !== null && newTailPoint !== void 0 ? newTailPoint : tail;
    const cloudRect = Object.assign(Object.assign({}, getInternalCloudRect(bounds.width, bounds.height)), { radius, tail: marker.background.pinned
            ? {
                x: x - bounds.x,
                y: y - bounds.y,
            }
            : { x, y } });
    return getCloudPath(cloudRect);
};
export const getCloudPath = (cloud) => {
    const { tail, width, height, center: { x, y }, radius, } = cloud;
    const effectiveRadius = Math.max(0, Math.min(radius, 1)) * 0.5 * Math.min(width, height);
    const segments = calculateCloudPath({
        x,
        y,
        width,
        height,
        radius: effectiveRadius,
    }, new Point(tail));
    if (segments) {
        return segmentsToPathData(segments, effectiveRadius);
    }
    return null;
};
function segmentsToPathData(path, radius) {
    const [initialSegment] = path;
    let moveX = 0;
    let moveY = 0;
    switch (initialSegment.type) {
        case 'arc':
            {
                const { center, angleFrom } = initialSegment;
                moveX = center.x + radius * Math.cos(angleFrom);
                moveY = center.y + radius * Math.sin(angleFrom);
            }
            break;
        case 'line':
            {
                const { start } = initialSegment;
                moveX = start.x;
                moveY = start.y;
            }
            break;
        default:
            return '';
    }
    const commands = [`M ${moveX} ${moveY}`];
    path.forEach(segment => {
        switch (segment.type) {
            case 'arc':
                {
                    const xp = segment.center.x +
                        segment.radius * Math.cos(segment.angleTo);
                    const yp = segment.center.y +
                        segment.radius * Math.sin(segment.angleTo);
                    commands.push(`A ${segment.radius} ${segment.radius} 0 0 1 ${xp} ${yp}`);
                }
                break;
            case 'line':
                commands.push(`L ${segment.end.x} ${segment.end.y}`);
                break;
            default:
                break;
        }
    });
    return commands.join(' ') + ' Z';
}
